import { request } from "@umijs/max";

// 获取角色列表
export async function getAdmRolePage({
  pageSize,
  current,
  filter,
  sorter,
}: {
  pageSize: number;
  current: number;
  filter: API.FormValues;
  sorter: string;
}) {
  return request("/api/admin/admRole/all", {
    method: "POST",
    data: {
      pageSize,
      current,
      filter,
      sorter,
    },
  });
}

// 获取全部角色
export async function getAdmRoleAll({ filter }: { filter: API.FormValues }) {
  return request("/api/admin/admRole/all", {
    method: "POST",
    data: {
      filter,
    },
  });
}

// 获取角色详情
export async function getAdmRoleInfo(values: API.FormValues) {
  return request("/api/admin/admRole/info", {
    method: "POST",
    data: values,
  });
}

// 创建角色
export async function addAdmRole(values: API.FormValues) {
  return request("/api/admin/admRole/add", {
    method: "POST",
    data: values,
  });
}

// 编辑角色
export async function editAdmRole(values: API.FormValues) {
  return request("/api/admin/admRole/edit", {
    method: "POST",
    data: values,
  });
}

// 删除角色
export async function removeAdmRole(values: API.FormValues) {
  return request("/api/admin/admRole/remove", {
    method: "POST",
    data: values,
  });
}
